import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PurchaseReturnReasonParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PurchaseReturnReason {
    id?: any;
    name:string;
}

export abstract class PurchaseReturnReasonData {

    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<PurchaseReturnReason[]>;
    abstract create(url: string, data: PurchaseReturnReason): Observable<PurchaseReturnReason[]>;
    abstract update(url: string, data: PurchaseReturnReason): Observable<PurchaseReturnReason>;
    abstract delete(url: string): Observable<any>;
}
